<template>
	<div class="reservation-node" :class="{ 'reservation-node--clickable': step >= i }">
		<Transition name="fade" mode="out-in">
			<div v-if="done" class="reservation-node__icon">
				<GlobalIcon name="tick-circle" :height="20" :width="20" />
			</div>
			<div v-else-if="active" class="reservation-node__icon reservation-node__icon--active"></div>
			<div v-else class="reservation-node__icon reservation-node__icon--inactive"></div>
		</Transition>
		<div class="reservation-node__title" :class="{ 'reservation-node__title--inactive': !done && !active }">{{ title }}</div>
		<div v-if="!last" class="reservation-node__arrow" :class="{ 'reservation-node__arrow--inactive': !done && !active }">
			<GlobalIcon name="arrow-right" :height="18" :width="18" />
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	title: string
	active?: boolean
	last?: boolean
	done?: boolean
	i: number
}>()

const step = inject<Ref<number>>('step')!
</script>

<style lang="scss">
@import './Node';
</style>
